var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14704_89549)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.4 11.2H26.6V6.99995C26.6 6.62865 26.4525 6.27255 26.19 6.01C25.9274 5.74745 25.5713 5.59995 25.2 5.59995H2.8C2.4287 5.59995 2.0726 5.74745 1.81005 6.01C1.5475 6.27255 1.4 6.62865 1.4 6.99995V11.2ZM1.4 11.2V21C1.4 21.3713 1.5475 21.7274 1.81005 21.9899C2.0726 22.2525 2.4287 22.4 2.8 22.4H25.2C25.5713 22.4 25.9274 22.2525 26.19 21.9899C26.4525 21.7274 26.6 21.3713 26.6 21V11.2H1.4ZM2.8 4.19995H25.2C25.9426 4.19995 26.6548 4.49495 27.1799 5.02005C27.705 5.54515 28 6.25734 28 6.99995V21C28 21.7426 27.705 22.4547 27.1799 22.9798C26.6548 23.505 25.9426 23.8 25.2 23.8H2.8C2.05739 23.8 1.3452 23.505 0.820101 22.9798C0.294999 22.4547 0 21.7426 0 21L0 6.99995C0 6.25734 0.294999 5.54515 0.820101 5.02005C1.3452 4.49495 2.05739 4.19995 2.8 4.19995Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.15115 11.3419C7.52605 11.0713 6.95734 10.9359 6.44502 10.9359H6.40152C5.78931 10.9359 5.36881 11.0471 5.14004 11.2694C4.94993 11.4531 4.85488 11.7769 4.85488 12.2409V12.2603C4.85488 12.7532 4.99987 13.0819 5.28987 13.2462C5.48642 13.3526 5.83764 13.446 6.34352 13.5266C6.85262 13.6071 7.23123 13.6764 7.47933 13.7344C7.72744 13.7892 7.93849 13.881 8.11249 14.0099C8.47337 14.2806 8.65381 14.7945 8.65381 15.5517V15.6677C8.65381 16.673 8.26232 17.3094 7.47933 17.5768C7.23767 17.6574 6.97184 17.7089 6.68185 17.7315V19.0461H5.95686V17.7315C5.10298 17.6799 4.39894 17.4882 3.84473 17.1563L4.16372 16.4797C4.89515 16.8663 5.61047 17.0597 6.30969 17.0597C7.12167 17.0597 7.59694 16.8003 7.73549 16.2815C7.78061 16.1107 7.80316 15.9142 7.80316 15.6919V15.5517C7.80316 15.3261 7.78705 15.1441 7.75483 15.0055C7.72261 14.867 7.65494 14.7542 7.55183 14.6672C7.38428 14.5222 6.98795 14.4014 6.36285 14.3047C5.80542 14.2177 5.42037 14.1356 5.2077 14.0582C4.99504 13.9809 4.81943 13.8971 4.68088 13.8069C4.54555 13.7135 4.42955 13.5975 4.33289 13.4589C4.13311 13.1689 4.03322 12.8096 4.03322 12.3811C4.03322 11.9493 4.07672 11.611 4.16372 11.3661C4.25072 11.1212 4.37638 10.9198 4.54071 10.7619C4.85327 10.4687 5.32531 10.3012 5.95686 10.2593V9.04614H6.68185V10.2593C7.36172 10.2883 7.93527 10.4043 8.40248 10.6073L8.15115 11.3419Z",
    fill: "#4A4A4A",
    stroke: "#4A4A4A",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0377 9.71606L14 9.71606",
    stroke: "#4A4A4A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0377 17.7161H14",
    stroke: "#4A4A4A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 13.7161L14 13.7161",
    stroke: "#4A4A4A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14704_89549"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardCheck);
export default __webpack_public_path__ + "static/media/card-check.91db09f639f18702efde45f8c9f0d8b5.svg";
export { ForwardRef as ReactComponent };